import { render, staticRenderFns } from "./Customized.vue?vue&type=template&id=8b926fb4&scoped=true&"
import script from "./Customized.vue?vue&type=script&lang=js&"
export * from "./Customized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b926fb4",
  null
  
)

export default component.exports